import React, { Component } from 'react';
import styled from 'styled-components';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import { insertReleaseNotes, updateReleaseNotes, getReleaseNotes } from '../../../services/apiServices';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import * as _ from 'lodash';
import DayJS from 'react-dayjs';
import UpdateReleaseNoteModal from '../../../components/molecule/Modals/UpdateReleaseNoteModal';

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
const FormControlStyled = styled(FormControl)`
  width: 60%;
`;
const SubmitButton = styled(Button)`
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
`;
const ReleaseNote = styled(TextField)`
  background: #eee;
  width: 100%;
`;
const AppVersion = styled(TextField)`
  width: 100%;
  margin-top: 20px;
  background: #eee;
`;
const TableStyle = styled(TableRow)`
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }
`;
const Wrapper = styled.div`
  height: 440px; 
  overflow: auto;
`;
const TableHeader = styled(TableHead)`
  position: sticky;
  top: 0;
  background: #eee;
`;
const TableHeadTag = styled(TableCell)`
  color: black;
  font-size: 0.85rem;
  font-weight: 550;
`;
const ReleaseNoteCheck = styled(TableCell)`
  text-align: center;
  font-weight: 400;
  font-size: medium;
`

export default class Body extends Component {
    constructor() {
        super();
        this.state = {
            releaseNotesText: '',
            appVersion: '',
            existingData: null,
            openModal: false,
            selectedRow: null,
        };
    }

    async componentDidMount() {
        await this.fetchReleaseNotes()
    }

    async fetchReleaseNotes() {
        try {
            const response = await getReleaseNotes()
            this.setState({ existingData: response })
        } catch (error) {
            toast.error(error);
        }
    }

    handleChange = (event) => {
        const { name, value } = event.target;

        if (name === "appVersion") {
            const regex = /^[0-9!@#$%^&*(),.?":{}|<>]+$/;
            if (regex.test(value) || value === '') {
                this.setState({
                    [name]: value
                });
            }
        } else {
            this.setState({
                [name]: value
            });
        }
    };

    handleModal = (row) => {
        this.setState({ openModal: true, selectedRow: row });
    };

    handleCloseModal = () => {
        this.setState({ openModal: false });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        const { releaseNotesText, appVersion } = this.state;
        const data = {
            app_version: appVersion,
            release_note: releaseNotesText,
        };

        const response = await insertReleaseNotes(data);
        if (response && response.status && response.status === 409) {
            toast.error(`${response?.data?.Msg}.`);

        } else if (response && response.status && response.status === 500) {
            toast.error(`${response?.data?.Msg}.`);
        }
        else if (response) {
            toast.success(`${response?.Msg}.`);
            this.setState({
                releaseNotesText: '',
                appVersion: '',
            });
            await this.fetchReleaseNotes();
        }
        else {
            toast.error(response?.data?.Msg);
            this.setState({
                releaseNotesText: '',
                appVersion: '',
            });
        }
    };

    extractColumns = (data, columns) => {
        return data?.map(row =>
            columns.reduce((obj, column) => {
                obj[column] = _.get(row, column);
                return obj;
            }, {})
        );
    };

    handleSave = async (id, editedData) => {
        const { app_version, text } = editedData;
        const data = {
            app_version,
            release_note: text,
        };

        try {
            await updateReleaseNotes(data);
            toast.success(`Updated Successfully`);
            await this.fetchReleaseNotes();
        } catch (error) {
            toast.error(error);
        }
    };


    render() {
        const { releaseNotesText, appVersion, existingData, selectedRow, openModal } = this.state;
        const isSubmitDisabled = releaseNotesText.trim() === '' || !appVersion;
        const releaseNoteCheck = existingData?.Msg

        return (
            <Container>
                <form onSubmit={this.handleSubmit}>
                    <FormControlStyled>
                        <ReleaseNote
                            id="release-notes"
                            name="releaseNotesText"
                            value={releaseNotesText}
                            onChange={this.handleChange}
                            label="Release Notes"
                            variant="outlined"
                            multiline
                            rows={4}
                            fullWidth
                            placeholder="Enter release notes here"
                        />
                        <AppVersion
                            id="app-version"
                            name="appVersion"
                            value={appVersion}
                            onChange={this.handleChange}
                            label="App Version"
                            variant="outlined"
                            fullWidth
                            placeholder="0.0.0.0"
                        />
                    </FormControlStyled>
                    <SubmitButton type="submit" variant="contained" color="primary" disabled={isSubmitDisabled}>
                        Submit Release Notes
                    </SubmitButton>
                </form>
                <Wrapper>
                    <Table stickyheader='true' aria-label="sticky table">
                        <TableHeader style={{ position: "sticky", top: 0 }}>
                            <TableRow>
                                <TableHeadTag>App Version</TableHeadTag>
                                <TableHeadTag>Request Date</TableHeadTag>
                                <TableHeadTag>Release Note</TableHeadTag>
                            </TableRow>
                        </TableHeader>
                        <TableBody >
                            {releaseNoteCheck ? (
                                <TableRow>
                                    <ReleaseNoteCheck colSpan={3} >{existingData.Msg}</ReleaseNoteCheck>
                                </TableRow>
                            ) : (
                                existingData && existingData.length > 0 && existingData?.map((row, index) => (
                                    <TableStyle key={index} onClick={() => this.handleModal(row)}>
                                        <TableCell>{row.app_version}</TableCell>
                                        <TableCell><DayJS format="ddd MMM D, YYYY h:mm a">{row.created}</DayJS></TableCell>
                                        <TableCell style={{ maxWidth: '10px' }}>{row.text}</TableCell>
                                    </TableStyle>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </Wrapper>
                {selectedRow && (
                    <UpdateReleaseNoteModal
                        isOpen={openModal}
                        handleClose={this.handleCloseModal}
                        rowData={selectedRow}
                        handleSave={this.handleSave}
                    />
                )}
            </Container>
        );
    }
}
